
import { currentMarkerStyle, pastMarkerStyle, startMarkerIconStyle } from "../styles/marker-styles";
import { Marker } from "@react-google-maps/api"


export default function EventMarker({ marker, index, listLength }) {


    const currentDate = new Date()
    const markerDate = new Date(marker.time)
    const dateDiff = Math.abs(markerDate.getTime() - currentDate.getTime())
    const dateDiffMinutes = Math.floor((dateDiff / 1000) / 60)
    const markerColor = dateDiffMinutes < 15 ? startMarkerIconStyle : currentMarkerStyle

    let markerStyle = (index + 1) === listLength ? markerColor : pastMarkerStyle

    return <Marker
        icon={markerStyle}
        key={index}
        style={{ zIndex: (index + 1) === listLength ? listLength : index }}
        position={{
            lat: marker.location_latitude,
            lng: marker.location_longitude
        }}
    />
}